import React from 'react';
import { useTranslation } from "react-i18next";

const Pagination = ({ totalItems, itemsPerPage, currentPage, onPageChange }) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const { t } = useTranslation();

  return (
    <div>
      <button 
        disabled={currentPage === 1} 
        onClick={() => onPageChange(currentPage - 1)}>
        {t("pagination.previous")}
      </button>
      {Array.from({ length: totalPages }, (_, index) => (
        <button
          key={index}
          onClick={() => onPageChange(index + 1)}
          style={{ margin: '0 5px', backgroundColor: currentPage === index + 1 ? 'lightblue' : 'white' }}
        >
          {index + 1}
        </button>
      ))}
      <button 
        disabled={currentPage === totalPages} 
        onClick={() => onPageChange(currentPage + 1)}>
        {t("pagination.next")}
      </button>
    </div>
  );
};

export default Pagination;
